<template>
    <header class="header-global">
        <base-nav type="default" effect="dark" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5 mx-auto" to="/">
                <img src="/img/brand/white-logo.png" alt="logo">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    STICKER STORE
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>
            <ul class="navbar-nav navbar-nav-hover align-items-lg-center" >
              <li class="nav-item">
                 <router-link  :to="{ name: 'home' }" class="nav-link nav-link-icon" role="button">
                <span class="nav-link-inner--text">Home</span>
                 </router-link>
             </li>
                 <li class="nav-item">
                 <router-link  :to="{ name: 'stickerSet' }" class="nav-link nav-link-icon">
                 <span class="nav-link-inner--text">Stickers</span>
                 </router-link>
                </li>
             </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.facebook.com/WAStickerAppsStore/" target="_blank" rel="noopener"
                       data-toggle="tooltip" title="Like us on Facebook">
                        <font-awesome-icon :icon="['fab','facebook-square']"/>
                        <span class="nav-link-inner--text d-lg-none">Facebook</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://twitter.com/WAStickerApp" target="_blank" rel="noopener"
                       data-toggle="tooltip" title="Follow us on Twitter">
                            <font-awesome-icon :icon="['fab','twitter']"/>
                        <span class="nav-link-inner--text d-lg-none">Twitter</span>
                    </a>
                </li>
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="https://play.google.com/store/apps/details?id=es.glstudio.wastickerapps" target="_blank" rel="noopener"
                       class="btn btn-neutral btn-icon">
                <span class="btn-inner--icon">
                   <font-awesome-icon :icon="['fab','google-play']" class="mr-2"/>
                </span>
                        <span class="nav-link-inner--text">Download</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from '@/components/BaseNav'
import CloseButton from '@/components/CloseButton'

export default {
  components: {
    BaseNav,
    CloseButton
  }
}
</script>
<style>
</style>
